import React, { Component } from 'react'
import { Row, Col, Form, Radio, InputNumber, Input, Upload, Button, Modal, Icon, DatePicker, Spin } from 'antd'
import locale from 'antd/lib/date-picker/locale/zh_CN'
import { app, api, config } from "../../app"
import command from "../notice/command"

const FormItem = Form.Item
const TextArea = Input.TextArea
const RadioGroup = Radio.Group

function beforeUpload (file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png']
    const is = format.indexOf(file.type) > -1
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn')
        return Promise.reject()
    }
    return Promise.resolve()
}

function normFile (e) {
    if (Array.isArray(e)) {
        return e
    }
    return e && e.fileList
}

/**
 * 检查字段
 * @param target
 * @param prompt
 */
function checkField (target, prompt) {
    if (target === undefined || target === '' || target === null) {
        app.alert(prompt, "warn", "50%")
        return false
    }
    return true
}

class DonationAdd extends Component {
    constructor (props) {
        super(props)
        this.state = {
            provinceList: [],
            teamList: [],
            playerList: [],
            panel_tab: 0,
            panel_loading: true,
        }
    }

    async componentDidMount () {
        this._isMounted = true
        let provinceList = await command.provinceDataNoToken()
        this.setState({ provinceList, panel_loading: false })
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 提交
     **/
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                console.log(values)
                if (!this.state.donate_object) {
                    if (values.donate_object_type === '1') {
                        app.alert("请选择捐赠对象——队伍")
                    } else {
                        app.alert("请选择捐赠对象——个人")
                    }
                    return
                }
                if (this.state.submit_loading) return false
                await this.setData({ submit_loading: true })
                if (values.donate_type === '1') {
                    values.indexno = app.getData('indexno')
                    values.account = app.getData('account')
                }
                let urls = []
                for (let i = 0; i < values.url.length; i++) {
                    let file = values.url[i]
                    if (file.response && file.response.flag === 1) {
                        urls.push(file.response.data.url)
                    }
                }
                values.donate_object = this.state.donate_object
                values.url = urls.join(':::')
                values.donate_time = values.donate_time.format('YYYY-MM-DD')
                let { flag, msg } = await app.post(api.DonateAdd, values)
                let state = { submit_loading: false }
                if (flag === 1) {
                    app.alert("捐赠成功,等待审核~", "success")
                    this.props.form.resetFields()
                    state.donate_object_text = null
                    state.donate_object = null
                } else {
                    app.alert(msg, "error")
                }
                this.setState(state)
            }
        })
    }

    /**
     * 上一步
     */
    handlePrev = (panel_tab) => {
        panel_tab -= 1
        let state = { panel_tab }
        switch (panel_tab) {
            case 1:
                state.teamList = []
                break
            case 2:
                state.playerList = []
                break
        }
        this.setData(state)
    }

    /**
     * 下一步
     */
    handleNext = async (panel_tab) => {
        panel_tab += 1
        let state = { panel_loading: false }, donate_object_type = this.props.form.getFieldValue("donate_object_type")
        switch (panel_tab) {
            case 1:
                if (!donate_object_type) {
                    app.alert("请选择捐赠对象！", "warn")
                    return
                }
                await this.setData({ panel_tab })
                break
            case 2:
                if (checkField(this.state.proviceSel, "请选择省份~")) {
                    await this.setData({ panel_tab, panel_loading: true })
                    state.teamList = await command.teamDataNoToken(this.state.proviceSel)
                    this.setState(state)
                }
                break
            case 3:
                if (checkField(this.state.teamSel, "请选择队伍~")) {
                    let team = this.state.teamList[this.state.teamSel]
                    if (donate_object_type === '1') {
                        await this.setData({ panel_tab: 0, donate_object_text: team.teamname, donate_object: team.teamno, proviceSel: null, teamSel: null })
                    } else {
                        await this.setData({ panel_tab, panel_loading: true })
                        state.playerList = await command.userDataNoToken(team.teamno)
                        this.setData(state)
                    }
                }
                break
            case 4:
                let user = this.state.playerList[this.state.playerSel]
                if (donate_object_type === '2') {
                    await this.setData({ panel_tab: 0, donate_object_text: `${user.vname}(${user.bsrno})`, donate_object: user.indexno, proviceSel: null, teamSel: null, playerSel: null })
                }
                break
            default:
                await this.setData({ panel_tab: 0, teamList: [], playerList: [], proviceSel: "", teamSel: [] })
                break
        }
    }

    render () {
        let { getFieldDecorator, getFieldValue } = this.props.form,
            { submit_loading, provinceList, donate_object_text, teamList, playerList, panel_tab, panel_loading } = this.state,
            formItemLayout = {
                labelCol: { span: 5 },
                wrapperCol: { span: 16, offset: 1 }
            },
            donate_type = getFieldValue("donate_type"),
            donate_object_type = getFieldValue("donate_object_type"),
            token = app.getToken()
        return (
            <div className="donation">
                <h1 className="donation-title">我要捐赠</h1>
                <Row className="donation-content">
                    <Col span={12}>
                        <FormItem
                            {...formItemLayout}
                            label="是否内部人员"
                        >
                            {getFieldDecorator('donate_type', {
                                rules: [{
                                    required: true, message: '请选择是否内部人员',
                                }],
                            })(
                                <RadioGroup>
                                    <Radio value="1" disabled={!token}>是</Radio>
                                    <Radio value="2">否</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="捐赠对象"
                        >
                            {getFieldDecorator('donate_object_type', {
                                rules: [{
                                    required: true, message: '请选择是否内部人员',
                                }],
                            })(
                                <RadioGroup onChange={() => this.setState({donate_object_text: null, donate_object: null})}>
                                    <Radio value="1">队伍</Radio>
                                    <Radio value="2">个人</Radio>
                                </RadioGroup>
                            )}
                            <span className="ant-form-text">
                                <span className="select-link"
                                      onClick={() => this.handleNext(0)}>选择{donate_object_type ? (donate_object_type === "1" ? "队伍" : "个人") : ""}</span>
                                <span>{donate_object_text}</span>
                            </span>
                        </FormItem>
                        {
                            donate_type !== "1" ? [
                                (<FormItem
                                    key="1"
                                    {...formItemLayout}
                                    label="捐赠人姓名"
                                >
                                    {getFieldDecorator('donate_name', {
                                        rules: [{
                                            required: true, message: '请输入捐赠人姓名',
                                        }],
                                    })(
                                        <Input/>
                                    )}
                                </FormItem>),
                                (<FormItem
                                    key="2"
                                    {...formItemLayout}
                                    label="捐赠人手机"
                                >
                                    {getFieldDecorator('mobile', {
                                        rules: [{
                                            required: true, message: '请输入捐赠人手机',
                                        }],
                                    })(
                                        <Input/>
                                    )}
                                </FormItem>)
                            ] : null
                        }
                        <FormItem
                            {...formItemLayout}
                            label="捐赠物品名称"
                        >
                            {getFieldDecorator('goods_name', {
                                rules: [{
                                    required: true, message: '请输入捐赠物品名称',
                                }],
                            })(
                                <Input/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="捐赠数量"
                        >
                            {getFieldDecorator('number', {
                                rules: [{
                                    required: true, message: '请输入捐赠数量',
                                }],
                            })(
                                <InputNumber style={{ width: "40%" }} min={1} precision={0}/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="捐赠日期"
                        >
                            {getFieldDecorator('donate_time', {
                                rules: [{
                                    required: true, message: '请选择捐赠日期',
                                }],
                            })(
                                <DatePicker style={{ width: "40%" }} locale={locale}/>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem
                            {...formItemLayout}
                            label="捐赠原因"
                        >
                            {getFieldDecorator('donate_reason')(
                                <TextArea rows={4}/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="捐赠物品说明"
                        >
                            {getFieldDecorator('describe')(
                                <TextArea rows={4}/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="物品图片"
                        >
                            {getFieldDecorator('url', {
                                rules: [
                                    { required: true, message: '请上传物品图片' },
                                ],
                                valuePropName: 'fileList',
                                getValueFromEvent: normFile,
                            })(
                                <Upload
                                    action={config.serverUrl + api.ImageUpload}
                                    accept='image/jpeg, image/jpg, image/png'
                                    data={{
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        token: app.getData('token'),
                                        upload_type: 'donate',
                                    }}
                                    name="image"
                                    beforeUpload={beforeUpload}
                                    listType="picture"
                                    className="upload-list-inline"
                                >
                                    <Button>
                                        <Icon type="upload"/> 点击上传
                                    </Button>
                                </Upload>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24} style={{ textAlign: "center" }}>
                        <Button style={{ width: "30%" }} size="large" type="primary" loading={submit_loading}
                                onClick={(e) => this.handleSubmit(e)}>提交审核</Button>
                        <div style={{ color: "red", marginTop: 10 }}>内部人员需要登陆系统后才可以进行捐赠</div>
                    </Col>
                </Row>
                <Modal
                    visible={panel_tab !== 0}
                    title={panel_tab === 1 ? "选择省份" : (panel_tab === 2 ? "选择队伍" : "选择人员")}
                    onCancel={() => this.handleNext(-1)}
                    okText={panel_tab < (donate_object_type === "2" ? 3 : 2) ? "下一步" : "确定"}
                    onOk={() => this.handleNext(panel_tab)}
                    cancelText="取消"
                    footer={
                        <div style={{ textAlign: "right" }}>
                            <Button onClick={() => this.handleNext(-1)}>取消</Button>
                            <Button onClick={() => this.handlePrev(panel_tab)} type="primary"
                                    hidden={panel_tab < 2}>上一步</Button>
                            <Button onClick={() => this.handleNext(panel_tab)} type="primary">
                                {panel_tab > (donate_object_type === "2" ? 2 : 1) ? "确定" : "下一步"}
                            </Button>
                        </div>
                    }
                    maskClosable={false}
                    destroyOnClose={true}
                    centered={true}
                    width='80%'
                >
                    <div hidden={!panel_loading}><Spin/></div>
                    <div hidden={panel_tab !== 1 || panel_loading}>
                        <RadioGroup onChange={(e) => this.setState({ proviceSel: e.target.value })}>
                            <Row>
                                {
                                    provinceList.map((pro, index) =>
                                        <Col span={4} key={index} style={{ padding: "5px 0" }}>
                                            <Radio className="no-select" key={index}
                                                   value={pro.area_name}>{pro.area_name}</Radio>
                                        </Col>
                                    )
                                }
                            </Row>
                        </RadioGroup>
                    </div>
                    <div hidden={panel_tab !== 2 || panel_loading}>
                        <RadioGroup onChange={(e) => this.setState({ teamSel: e.target.value })}>
                            <Row>
                                {
                                    teamList.map((team, index) => (
                                        <Col span={8} key={index} style={{ padding: "5px 0" }}>
                                            <Radio key={index} value={index}>{team.teamname}</Radio>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </RadioGroup>
                    </div>
                    <div hidden={panel_tab !== 3 || panel_loading}>
                        <RadioGroup onChange={(e) => this.setState({ playerSel: e.target.value })}>
                            <Row>
                                {
                                    playerList.map((player, index) => (
                                        <Col span={8} key={index} style={{ padding: "5px 0" }}>
                                            <Radio key={index}
                                                   value={index}>{player.vname}({player.bsrno})</Radio>
                                        </Col>))
                                }
                            </Row>
                        </RadioGroup>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(DonationAdd)



// WEBPACK FOOTER //
// ./src/routes/donation/DonationAdd.jsx